import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import { ZAPIER_HELPDOC_URL } from 'constants/HelpDocConstants'
import Input from 'shared-web/src/components/Input'
import style from '../components/style.styl'

const ZapierIntegrationLink = "https://zapier.com/developer/invite/37478/e0723233b58a75984fc47535684ff803/"

class Zapier extends Component {
  render() {
    const { accessToken } = this.props.apiKey
    return (
      <div>
        <p>If you’re already using Zapier, you know how powerful it can be.</p>
        <p>With Drift and Zapier, you’ll be able to do things like sync contacts from
          the tools that you’re already using like SalesForce or log a new event for a
          user based on something they’ve done in Zendesk.
          <a target="_blank" href={ZAPIER_HELPDOC_URL}> Learn more</a>
        </p>
        <p>You can set up your Zapier integration using the Drift Access Token below.</p>
        <Input
          placeholder="e.g. 123456"
          label="DRIFT ACCESS TOKEN"
          helperLabel="Use this Access Token in Zapier to connect it with your Drift account."
          value={accessToken}
          readOnly={true}
        />
        <p>
          <a className={style.IntegrationLink} target="_blank" href={ZapierIntegrationLink}>Open integration page on Zapier &gt;</a>
        </p>
      </div>
    )
  }
}

export const ZapierContainer = makeDefaultFailedContainer(Zapier, {
  listenTo: ['stores.ApiKeyStore'],
  fetch: {
    apiKey() {
      return this.app.stores.ApiKeyStore.getApiKeyForCurrentOrg()
    }
  }
})

export default ZapierContainer



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Zapier.js